export type ThemeType = 'default' | 'dark';

let grir: any = undefined;
export const setGlobalRir = (rir: any) => {
    grir = rir;
}

const getThemeType = (): ThemeType => {
    const theme = document.documentElement.getAttribute('theme');
    if (theme) return theme as ThemeType;
    return 'default';
}
export const setThemeType = (themeType: ThemeType) => {
    localStorage.setItem('theme', themeType);
    grir.changeTheme(themeType);
}
export const setGlobalThemeType = (themeType: ThemeType) => {
    if ( ['default', 'dark'].includes(themeType) )
        grir.changeTheme(themeType);
    else
        grir.changeTheme('default');
}

export const toggleHtmlTheme = () => {
    const themeType = getThemeType();
    if (themeType === 'default') setThemeType('dark');
    else if (themeType === 'dark') setThemeType('default');
}
